import "./homeSpaces.css";
import BackIcon from "../../_shared/components/BackIcon";
import { Link, Routes, Route, useNavigate, Navigate } from "react-router-dom";
import useRestResource from "../../_shared/hooks/useRestList";
import React, { useEffect, useRef, useState } from "react";
import YellowButton from "../../../assets/images/icons/Pulsante_lay.png";
import MarkerPointVertical from "../../_shared/components/MarkerPointVertical";
import LayoutCombinations from "../LayoutCombinations";
import { CSSTransition } from "react-transition-group";
import { Transition } from "react-transition-group";
import AppText from "../../_shared/components/AppText";
import SideMenu from "../../_shared/components/SideMenu";

function HomeSpaces(props) {
  const { setSplash } = props;
  useEffect(() => setSplash(false), []);
  const [rooms] = useRestResource("/rooms");
  const [selectedRoom, setSelectedRoom] = useState();
  const [selectedLayout, setSelectedLayout] = useState();

  function getRoom(room) {
    return (
      <div
        className="roomCard"
        style={
          selectedRoom
            ? selectedRoom?.id === room?.id
              ? { opacity: 1 }
              : { opacity: 0.2 }
            : { opacity: 1 }
        }
        onClick={() => setSelectedRoom(room)}
      >
        <img
          alt=""
          src={room?.image}
          style={{ width: 200, objectFit: "contain", marginBottom: 5 }}
        ></img>
        <AppText bold small>
          {room?.name?.it}
        </AppText>
        <AppText small>{room?.name?.en}</AppText>
      </div>
    );
  }
  function getMarkerHeight(percentageY) {
    return 210 - (240 * percentageY) / 100;
  }

  function getLayouts() {
    return (
      <div className="layouts">
        {selectedRoom?.layouts?.map((lay) => {
          return (
            <div className="layCard" onClick={() => setSelectedLayout(lay)}>
              <div
                style={{
                  backgroundImage: `url(${lay?.layoutImage})`,
                  marginTop: 50,
                  height: 200,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                }}
              >
                <div
                  style={{
                    position: "relative",
                    left: lay?.pickPoint?.percentageX
                      ? `${lay?.pickPoint?.percentageX}%`
                      : 0,
                    top: lay?.pickPoint?.percentageY
                      ? `${lay?.pickPoint?.percentageY}%`
                      : 0,
                  }}
                  key={lay?._id}
                  className="animate-delay1"
                >
                  <img
                    alt=""
                    src={YellowButton}
                    style={{
                      height: 50,
                      width: 50,
                    }}
                  ></img>

                  <div className="row animate-delay2">
                    <MarkerPointVertical
                      markerHeight={getMarkerHeight(
                        lay?.pickPoint?.percentageY ?? 1
                      )}
                    ></MarkerPointVertical>
                    <div
                      style={{
                        position: "absolute",
                        left: 30,
                        top: "100%",
                      }}
                    >
                      <AppText small bold>
                        {lay?.layoutName?.it}
                      </AppText>
                      <AppText small>{lay?.layoutName?.en}</AppText>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
  return selectedLayout ? (
    <Navigate to={`/layout-combinations/${selectedLayout?._id}`}></Navigate>
  ) : (
    <div className="rootMenu">
      <SideMenu></SideMenu>
      <div className="rootContent">
        <div className="row">
          <div>
            <BackIcon />
          </div>
          <div>
            <div className="titleHomeSpaces">
              Scegli il tuo ambiente della casa
            </div>
            <div className="subtitleHomeSpaces"> Choose your room</div>
          </div>
        </div>
        <div className="rooms">
          {rooms
            ?.filter((room) => room.parentRoom === "0")
            .map((room) => getRoom(room))}
        </div>
        {selectedRoom && getLayouts()}
      </div>
    </div>
  );
}

export default HomeSpaces;
